module.exports = __webpack_public_path__ + "static/media/curlegance-1.4e363e85.jpg";